import React from "react";

const ImagePreloader = () => {

	return (
		<div className="Portfolio col-md-3 placeholder shimmer">
			<div className="faux-image-wrapper">
				<div className="faux-image"></div>
			</div>
		</div>
	)
}
export default ImagePreloader;